/* Combine optional service checkboxes into one contact[Services of interest] field. */
(function () {
  function syncServices(fieldset) {
    var hidden = fieldset.querySelector('[data-cb-contact-services-value]');
    if (!hidden) return;
    var selected = [];
    fieldset.querySelectorAll('[data-cb-contact-service]:checked').forEach(function (el) {
      if (el.value) selected.push(el.value);
    });
    hidden.value = selected.join(', ');
  }

  function initFieldset(fieldset) {
    if (fieldset.dataset.cbServicesInit) return;
    fieldset.dataset.cbServicesInit = '1';
    fieldset.addEventListener('change', function () {
      syncServices(fieldset);
    });
    var form = fieldset.closest('form');
    if (form) {
      form.addEventListener('submit', function () {
        syncServices(fieldset);
      });
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-cb-contact-services]').forEach(initFieldset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
